export enum LoginPlatformType {

    Email = "Email",
    Token = "Token",
}
